namespace Areas.Project.Profile {
    "use strict";

    export function updateProject() {
        const form = $("#ProjectForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Project/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function lookupArchitectTemplate(itemData: any, itemIndex: any, itemElement: any) {
        return Areas.lookupActiveTemplate((i) => i.principalArchitectLk)(itemData, itemIndex, itemElement);
    }

    export function lookupProjectTemplate(itemData: any, itemIndex: any, itemElement: any) {
        return Areas.lookupActiveTemplate((i) => i.projectTypeLk)(itemData, itemIndex, itemElement);
    }

    export function newMilestone(e: any) {
        setProjectId("MilestoneDataGrid", e);
    }

    function setProjectId(gridName: string, e: any) {
        const dataGrid = $(`#${gridName}`).dxDataGrid("instance");
        const projectId = dataGrid.option("projectId");

        e.data.projectId = projectId;        
    }    
        
}